export const publicStatsUrl =
  "https://metabase-v2.immersion-facile.beta.gouv.fr/public/dashboard/8129056a-dace-45f9-8a5a-cb075f70302a";
